import { message } from 'antd';
import axios from 'axios';
import { REQUEST_LOADING } from 'constants/alerts';

const urlToFile = async (url, filename, mimeType) => {
  if (!url) return undefined;

  const res = await fetch(url);
  const buf = await res.arrayBuffer();
  return new File([buf], filename, { type: mimeType });
};

const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String = reader.result
        .replace('data:', '')
        .replace(/^.+,/, '');

      resolve(base64String);
    };
    reader.onerror = (error) => reject(error);
  });
};

const base64toBlob = async (base64Data, contentType = '') => {
  const base64Response = await fetch(
    `data:${contentType};base64,${base64Data}`
  );
  const blob = await base64Response.blob();

  return blob;
};

const normFile = (e) => {
  if (Array.isArray(e)) {
    return e;
  }

  return e?.fileList;
};

const downloadDocs = async (title, path, responseType, blobType) => {
  const hide = message.loading(REQUEST_LOADING, 100);
  const res = await axios.get(path, { responseType });
  if (res.status === 200) {
    const blob = new Blob([res.data], { type: blobType });
    const link = document.createElement('a');
    const blobUrl = window.URL.createObjectURL(blob);

    link.href = blobUrl;
    link.download = title;

    link.click();
    link.remove();
    message.success('Скачивание завершено');
    hide();
  } else {
    hide();
    message.error('Не удалось скачать документ');
    throw new Error('Network error when downloading file');
  }
};

export const downloadMedia = async (url, name) => {
  const hide = message.loading(REQUEST_LOADING, 100);
  if (url.includes(process.env.REACT_APP_HOSTNAME)) {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement('a');
      link.download = name;
      link.href = window.URL.createObjectURL(blob);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      message.error('Не удалось скачать изображение');
    } finally {
      hide();
    }
  }
};

export const handleDownloadPDF = async (name) => {
  try {
    await downloadDocs(
      name,
      `${process.env.REACT_APP_HOSTNAME}/chat/v1/media/${name}`,
      'arraybuffer',
      'application/pdf'
    );
  } catch (error) {
    message.error('Не удалось скачать PDF файл');
  }
};

export const handleDownloadExel = async (data, name) => {
  const hide = message.loading(REQUEST_LOADING);

  try {
    const blob = await base64toBlob(
      data,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'
    );

    const blobUrl = window.URL.createObjectURL(new Blob([blob]));

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = decodeURI(name);
    link.click();

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    message.error('Не удалось скачать Excel документ');
  } finally {
    hide();
  }
};

const formatBytes = (bytes) => {
  if (!bytes) {
    return;
  }

  const units = ['байтов', 'КБ', 'МБ'];
  let i = 0;

  while (bytes >= 1024 && i < 3) {
    bytes /= 1024;
    i += 1;
  }

  return `${Math.floor(bytes)} ${units[i]}`;
};

export {
  toBase64,
  urlToFile,
  base64toBlob,
  normFile,
  downloadDocs,
  formatBytes,
};

export const downloadFile = async (
  file_path,
  fileName,
  isTemplate = false,
  otherUrl = null
) => {
  const hide = message.loading('Скачивание файла...', 0);

  try {
    const link = file_path;
    const fileRealName = fileName || 'Error.xlsx';
    const path =
      otherUrl ||
      (isTemplate
        ? 'media/history_upload/template/'
        : `external/media/history_upload/?file_path=${link}`);

    const res = await axios.get(path, {
      responseType: 'blob',
    });

    const blob = new Blob([res.data], {
      type: res.headers['content-type'],
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = fileRealName;
    document.body.appendChild(a);
    a.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    message.success('Файл успешно скачан');
  } catch (error) {
    message.error(
      error.response?.data?.detail || 'Ошибка при скачивании файла'
    );
  } finally {
    hide();
  }
};
